import { useState } from "react";
import api from "@api";
import { DEFAULT_LEADERBOARD_DISPLAY_CONFIG_BY_SPORT } from "../../../../utils/leaderboardSections.js";
import "./LeaderboardSettings.css";

function LeaderboardSettings({ id, pageId, page }) {
 const [leaderboardFilters, setLeaderboardFilters] = useState({
  showAll: page?.pageSettings?.content?.filters?.showAll ?? true,
  showRegular: page?.pageSettings?.content?.filters?.showRegular ?? true,
  showTournament: page?.pageSettings?.content?.filters?.showTournament ?? true,
 });

 const sportName = page?.organization?.sports?.[0]?.type || null;
 const existingContent = page?.pageSettings?.content || {};

 const leaderboardOptions = sportName
  ? DEFAULT_LEADERBOARD_DISPLAY_CONFIG_BY_SPORT[sportName] || []
  : [];

 const defaultKeys = leaderboardOptions.map((item) => item.key);

 const [visibleStatKeys, setVisibleStatKeys] = useState(
  page?.pageSettings?.content?.visibleStatKeys || defaultKeys
 );

 const handleToggleVisibleStat = (key, checked) => {
  if (checked) {
   setVisibleStatKeys((prev) => [...prev, key]);
  } else {
   setVisibleStatKeys((prev) => prev.filter((item) => item !== key));
  }
 };

 const handleSave = async () => {
  try {
   await api.put(`/api/organization-page/${id}/${pageId}`, {
    content: {
     ...existingContent,
     filters: leaderboardFilters,
     visibleStatKeys,
    },
   });

   alert("Settings saved.");
  } catch (err) {
   console.error("Failed to save leaderboard settings:", err);
   alert("Could not save settings.");
  }
 };

 return (
  <div className="leaderboard-settings">
   <div className="leaderboard-settings-card">
    <div className="leaderboard-settings-header">
     <h2 className="leaderboard-settings-title">Leaderboard Settings</h2>
     <p className="leaderboard-settings-subtext">
      Control which leaderboard tabs and stat sections appear publicly.
     </p>
    </div>

    <div className="leaderboard-settings-group">
     <h3 className="leaderboard-settings-group-title">Game Type Tabs</h3>
     <p className="leaderboard-settings-group-subtext">
      Choose which leaderboard tabs users can switch between.
     </p>

     <div className="leaderboard-settings-options">
      <label className="leaderboard-settings-option">
       <div>
        <div className="leaderboard-settings-option-title">Show All</div>
        <div className="leaderboard-settings-option-subtext">
         Display the combined leaderboard view.
        </div>
       </div>
       <input
        type="checkbox"
        checked={leaderboardFilters.showAll}
        onChange={(e) =>
         setLeaderboardFilters((prev) => ({
          ...prev,
          showAll: e.target.checked,
         }))
        }
       />
      </label>

      <label className="leaderboard-settings-option">
       <div>
        <div className="leaderboard-settings-option-title">Show Regular</div>
        <div className="leaderboard-settings-option-subtext">
         Display regular season leaderboard stats.
        </div>
       </div>
       <input
        type="checkbox"
        checked={leaderboardFilters.showRegular}
        onChange={(e) =>
         setLeaderboardFilters((prev) => ({
          ...prev,
          showRegular: e.target.checked,
         }))
        }
       />
      </label>

      <label className="leaderboard-settings-option">
       <div>
        <div className="leaderboard-settings-option-title">Show Tournament</div>
        <div className="leaderboard-settings-option-subtext">
         Display tournament leaderboard stats.
        </div>
       </div>
       <input
        type="checkbox"
        checked={leaderboardFilters.showTournament}
        onChange={(e) =>
         setLeaderboardFilters((prev) => ({
          ...prev,
          showTournament: e.target.checked,
         }))
        }
       />
      </label>
     </div>
    </div>

    <div className="leaderboard-settings-group">
     <h3 className="leaderboard-settings-group-title">Visible Leaderboards</h3>
     <p className="leaderboard-settings-group-subtext">
      Choose which stat leader sections appear on the public leaderboard.
     </p>

     {leaderboardOptions.length === 0 ? (
      <div className="leaderboard-settings-empty">
       No leaderboard options found for this sport.
      </div>
     ) : (
      <div className="leaderboard-settings-grid">
       {leaderboardOptions.map((item) => (
        <label
         key={item.key}
         className="leaderboard-settings-stat-card"
        >
         <div>
          <div className="leaderboard-settings-option-title">
           {item.title}
          </div>
          <div className="leaderboard-settings-option-subtext">
           {item.valueLabel} • {item.type === "team" ? "Team" : "Player"}
          </div>
         </div>

         <input
          type="checkbox"
          checked={visibleStatKeys.includes(item.key)}
          onChange={(e) =>
           handleToggleVisibleStat(item.key, e.target.checked)
          }
         />
        </label>
       ))}
      </div>
     )}
    </div>

    <div className="leaderboard-settings-actions">
     <button
      type="button"
      className="leaderboard-settings-save-btn"
      onClick={handleSave}
     >
      Save Settings
     </button>
    </div>
   </div>
  </div>
 );
}

export default LeaderboardSettings;